import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import Deliverability from '../enums/@shared/Deliverability';
import { EPhonePlatform } from '@leedpulse-monorepo/enums';
import { ESmsRole } from '@leedpulse-monorepo/enums';

export default class SMS {
  private _id: string;
  private _idPartner: string;
  private _created: Date;
  private _customer: string;
  private _deliverability: Deliverability;
  private _idApiKey: string;
  private _idContact: string;
  private _attempts: number;
  private _platform: EPhonePlatform;
  private _role: ESmsRole;
  private _readedBackoffice: boolean;
  private _readedFrontend: boolean;
  private _manualsending: boolean;
  private _message: string;
  private _segments: number;
  private _price: number;
  private _sender: string;
  private _createdBy: string;

  constructor(
    id: string,
    idPartner: string,
    created: Date,
    customer: string,
    deliverability: Deliverability,
    idApiKey: string,
    idContact: string,
    attempts: number,
    platform: EPhonePlatform,
    role: ESmsRole,
    readedBackoffice: boolean,
    readedFrontend: boolean,
    manualsending: boolean,
    message: string,
    segments: number,
    price: number,
    sender: string,
    createdBy: string
  ) {
    this._id = id;
    this._idPartner = idPartner;
    this._created = created;
    this._customer = customer;
    this._deliverability = deliverability;
    this._idApiKey = idApiKey;
    this._idContact = idContact;
    this._attempts = attempts || 1;
    this._platform = platform;
    this._role = role;
    this._readedBackoffice = readedBackoffice;
    this._readedFrontend = readedFrontend;
    this._manualsending = manualsending;
    this._message = message;
    this._segments = segments;
    this._price = price;
    this._sender = sender;
    this._createdBy = createdBy;
  }

  get id(): string {
    return this._id;
  }

  get idPartner(): string {
    return this._idPartner;
  }

  get created(): Date {
    return this._created;
  }

  get customer(): string {
    return this._customer;
  }

  get deliverability(): Deliverability {
    return this._deliverability;
  }

  get idApiKey(): string {
    return this._idApiKey;
  }

  get idContact(): string {
    return this._idContact;
  }

  get attempts(): number {
    return this._attempts || 1;
  }

  get platform(): EPhonePlatform {
    return this._platform;
  }

  get role(): ESmsRole {
    return this._role;
  }

  get readedBackoffice(): boolean {
    return this._readedBackoffice;
  }

  get readedFrontend(): boolean {
    return this._readedFrontend;
  }

  get manualsending(): boolean {
    return this._manualsending;
  }

  get message(): string {
    return this._message;
  }

  get segments(): number {
    return this._segments;
  }

  get price(): number {
    return this._price;
  }

  get sender(): string {
    return this._sender;
  }

  get createdBy(): string {
    return this._createdBy;
  }

  public copyWith({ readedBackoffice }: { readedBackoffice: boolean }): SMS {
    return new SMS(
      this._id,
      this._idPartner,
      this._created,
      this._customer,
      this._deliverability,
      this._idApiKey,
      this._idContact,
      this._attempts,
      this._platform,
      this._role,
      readedBackoffice,
      this._readedFrontend,
      this._manualsending,
      this._message,
      this._segments,
      this._price,
      this._sender,
      this._createdBy
    );
  }

  static fromFirestore(
    data: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): SMS {
    const docData = data.data();
    return new SMS(
      data.id,
      docData.id_partner,
      new Date(docData.created),
      docData.customer,
      docData.deliverability,
      docData.id_api_key,
      docData.id_contact,
      docData.attempts || 1,
      docData.platform,
      docData.role,
      docData.readed_backoffice,
      docData.readed_frontend,
      docData.manualsending,
      docData.message,
      docData.segments,
      docData.price,
      docData.sender,
      docData.created_by
    );
  }

  static fromApi(data: any): SMS {
    return new SMS(
      data.id,
      data.id_partner,
      new Date(data.created),
      data.customer,
      data.deliverability,
      data.id_api_key,
      data.id_contact,
      data.attempts || 1,
      data.platform,
      data.role,
      data.readed_backoffice,
      data.readed_frontend,
      data.manualsending,
      data.message,
      data.segments,
      data.price,
      data.sender,
      data.created_by
    );
  }
}
